module.exports = __webpack_public_path__ + "static/media/cattolica-logo.aa18f9c2.png";